function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { Event } from 'meteora';
var ScrollLocker = /*#__PURE__*/function () {
  function ScrollLocker(el) {
    _classCallCheck(this, ScrollLocker);
    this.body = document.querySelector('html');
    this.el = el;
    this.y = 0;
  }
  _createClass(ScrollLocker, [{
    key: "lock",
    value: function lock() {
      this.y = window.pageYOffset;
      this.el.style.height = window.innerHeight + 'px';
      this.el.style.overflow = 'hidden';
      this.el.scrollTop = this.y;
      window.dispatchEvent(new Event('resize'));
    }
  }, {
    key: "unlock",
    value: function unlock() {
      this.el.style.height = 'auto';
      this.el.style.overflow = 'visible';
      this.body.scrollTop = this.y;
      window.dispatchEvent(new Event('resize'));
    }
  }]);
  return ScrollLocker;
}();
export { ScrollLocker as default };